import cookies from 'js-cookie';
import * as v from 'valibot';
import { BOT_SCORE_COOKIE_NAME, IS_VERIFIED_BOT_COOKIE_NAME } from './constants';

const verifiedBotSchema = v.pipe(
  v.string(),
  v.transform(value => value === '1'),
  v.boolean(),
);
const botScoreSchema = v.pipe(v.string(), v.transform(Number), v.number());

export function getBotCookies() {
  const botScore = cookies.get(BOT_SCORE_COOKIE_NAME) ?? '';
  const isVerifiedBot = cookies.get(IS_VERIFIED_BOT_COOKIE_NAME) ?? '';

  const validatedIsVerifiedBot = v.safeParse(verifiedBotSchema, isVerifiedBot);
  const validatedBotScore = v.safeParse(botScoreSchema, botScore);

  const score = validatedBotScore.success ? validatedBotScore.output : 0;
  const isAKnownConfirmedBot = validatedIsVerifiedBot.success
    ? validatedIsVerifiedBot.output
    : false;
  // Taken from https://developers.cloudflare.com/bots/concepts/bot-score/#bot-groupings
  const isLikelyBot = score > 0 && score < 30;
  return {
    botScore: score,
    isBot: isLikelyBot,
    isVerifiedBot: isAKnownConfirmedBot,
  };
}
